export enum WindowSizesEnum {
  TabletBreakpoint = 768,
  SmallDesktopBreakpoint = 1200,
  LargeDesktopBreakpoint = 1440,
}
